import { SHIPMENTS_TAB, SHIPMENTS_TABLE_TABS } from "../../constants";
import { ActionIcon, BulkAction, LogsIcon, PrintIcon } from "../Icon";
import { ShipmentIcon } from "../Icon/ShipmentIcon";

export const ActionCellItems = ({ onActionClick, onItemPrintClick, onShipmentClick, onPrintIcon }) => {
  const shipmentTab = localStorage.getItem(SHIPMENTS_TAB);
  const ClickAndCollectFilteredActionItems = shipmentTab !== SHIPMENTS_TABLE_TABS.CLICK_AND_COLLECT.value;

  const items = [
    ClickAndCollectFilteredActionItems && {
      component: ShipmentIcon,
      onClick: onItemPrintClick,
      name: "Process Shipment",
    },
    {
      component: ActionIcon,
      onClick: onShipmentClick,
      name: "Actions",
    },
    shipmentTab === SHIPMENTS_TABLE_TABS.CLICK_AND_COLLECT.value && {
      component: PrintIcon,
      onClick: onPrintIcon,
      name: "Print",
    },
    {
      component: LogsIcon,
      onClick: onActionClick,
      name: "Logs",
    },
  ];

  return items.filter(Boolean);
};
